/**
 * Per-tab call ownership. Ringing state is a map of callControlIds; this tab
 * owns at most one in-call / pending-answer id (never "the first ringing card").
 */

/**
 * @param {{
 *   payloadTabSessionId?: string|null,
 *   localTabSessionId: string,
 *   callControlId: string,
 *   activeCallControlId?: string|null,
 *   outboundDialingCallControlId?: string|null,
 *   thisTabClaimedCallControlId?: string|null
 * }} input
 * @returns {boolean}
 */
export function isCallAnsweredOwnedByThisTab({
  callControlId,
  payloadTabSessionId,
  localTabSessionId,
  activeCallControlId,
  outboundDialingCallControlId,
  thisTabClaimedCallControlId
}) {
  if (!callControlId) return false;

  // Reload / reconnect can re-broadcast call_answered with our tabSessionId.
  // Only bind UI if this page session already claimed / dialed / owns that id.
  const hasLocalContext = callControlId === activeCallControlId
    || callControlId === outboundDialingCallControlId
    || callControlId === thisTabClaimedCallControlId;

  if (!hasLocalContext) {
    return false;
  }

  const payloadTab = typeof payloadTabSessionId === 'string'
    ? payloadTabSessionId.trim()
    : '';
  const localTab = typeof localTabSessionId === 'string'
    ? localTabSessionId.trim()
    : '';

  if (payloadTab) {
    return Boolean(localTab) && payloadTab === localTab;
  }

  return true;
}

/**
 * Socket hangup/fail of another tab's call must not POST /hangup or tear down JsSIP.
 * @param {{
 *   callControlId: string,
 *   activeCallControlId?: string|null,
 *   outboundDialingCallControlId?: string|null,
 *   thisTabClaimedCallControlId?: string|null
 * }} input
 * @returns {boolean}
 */
export function isHangupOwnedByThisTab({
  callControlId,
  activeCallControlId,
  outboundDialingCallControlId,
  thisTabClaimedCallControlId
}) {
  if (!callControlId) return false;
  return callControlId === activeCallControlId
    || callControlId === outboundDialingCallControlId
    || callControlId === thisTabClaimedCallControlId;
}
